import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { navigate } from '../lib/router';
import logo from '../assets/logo.png';

export default function Login() {
  const { requestOtp, verifyOtp } = useAuth();
  const toast = useToast();
  const [step, setStep] = useState('email'); // 'email' | 'otp'
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [pending, setPending] = useState(false);

  const sendOtp = async (e) => {
    e.preventDefault();
    setPending(true);
    try {
      const res = await requestOtp(email.trim());
      if (res && res.status === false) throw new Error(res.message || 'Failed to send OTP');
      toast.success(res?.message || 'OTP sent');
      setStep('otp');
    } catch (err) {
      toast.error(err.message || 'Failed to send OTP');
    } finally {
      setPending(false);
    }
  };

  const submitOtp = async (e) => {
    e.preventDefault();
    setPending(true);
    try {
      await verifyOtp(email.trim(), otp.trim());
      navigate('/');
    } catch (err) {
      toast.error(err.message || 'Invalid OTP');
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="login">
      {step === 'email' ? (
        <form className="login__card" onSubmit={sendOtp}>
          <img className="login__logo" src={logo} alt="TraveLens" />
          <h1>TraveLens Admin</h1>
          <p className="login__hint">Sign in to your AI admin console</p>
          <label className="field">
            <span>Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus placeholder="you@travelens.ai" />
          </label>
          <button className="btn btn--primary" type="submit" disabled={pending}>
            {pending ? 'Sending…' : 'Send OTP'}
          </button>
        </form>
      ) : (
        <form className="login__card" onSubmit={submitOtp}>
          <img className="login__logo" src={logo} alt="TraveLens" />
          <h1>Enter OTP</h1>
          <p className="login__hint">We sent a code to {email}.</p>
          <label className="field">
            <span>OTP</span>
            <input value={otp} onChange={(e) => setOtp(e.target.value)} required autoFocus inputMode="numeric" placeholder="6-digit code" />
          </label>
          <button className="btn btn--primary" type="submit" disabled={pending}>
            {pending ? 'Verifying…' : 'Verify & sign in'}
          </button>
          <button className="btn btn--ghost" type="button" disabled={pending} onClick={() => { setOtp(''); setStep('email'); }}>
            Change email
          </button>
        </form>
      )}
    </div>
  );
}
